import { blue100, blue200 } from "styles";

export const styles = {
  trialBanner: {
    position: "relative",

    backgroundColor: blue100,
    padding: { xs: "12px 16px", lg: "12px 24px" },
    paddingRight: { xs: "54px", lg: "24px" },
    borderBottom: `1px solid ${blue200}`,

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "4px",

    "@media (max-width: 1080px)": {
      alignItems: "flex-start",
      justifyContent: "flex-start",
    },
  },
  trialWrapper: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    alignItems: { xs: "flex-start", md: "center" },
    gap: "4px",
  },
  closeButton: {
    position: "absolute",
    top: "12px",
    right: { xs: "16px", md: "24px" },
    padding: 0,
    zIndex: 2,
    color: "#393939",

    ":hover": {
      border: "none",
    },
  },
};
